<script setup lang="ts">
import { default as ButtonEl } from '@/components/shared/Button.vue';

interface Props {
  isPlaying: boolean;
}

withDefaults(defineProps<Props>(), {});

const emit = defineEmits(['playVideo', 'pauseVideo', 'resetView']);
</script>

<template>
  <div class="flex flex-col items-center justify-between w-full px-32">
    <ButtonEl
      v-if="!isPlaying"
      class="content bold mb-[68px]"
      text=""
      iconSize="text-8xl"
      :icon="['fas', 'fa-play']"
      @click="emit('playVideo')"
    />

    <ButtonEl
      v-if="isPlaying"
      class="content bold mb-[68px]"
      text=""
      iconSize="text-8xl"
      :icon="['fas', 'fa-pause']"
      @click="emit('pauseVideo')"
    />

    <ButtonEl
      class="content bold"
      text="global.restart"
      typography="h700"
      :icon="['fal', 'fa-undo-alt']"
      @click="emit('resetView')"
    />
  </div>
</template>
